module.exports = __webpack_public_path__ + "static/media/Lobbyists header.54a7af48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Lobbyists header.png
// module id = 346
// module chunks = 0